import { camelCaseObjectToSnakeCase } from '../../../utils/convert-case';

function bytesToBase64(bytes) {
  const binString = Array.from(bytes, (byte) => String.fromCodePoint(byte)).join('');
  return btoa(binString);
}

const prepareAndEncodeData = (data, details) => {
  const snakeCaseDetails = camelCaseObjectToSnakeCase(details);

  return bytesToBase64(new TextEncoder().encode(JSON.stringify({ ...data, ...snakeCaseDetails })));
};

export default prepareAndEncodeData;
